import {OrderItem} from './OrderItem';
import { BrandCard } from './BrandCard';
import {ReviewItem} from './ReviewItem';
import {ProductCard} from './ProductCard';
import {ProductHomeCard} from './productHomeCard';
import {ProductCategoryCard, ProductCategoryCardDetail} from './ProductCategoryCard';
import {BrandCardDetail} from './BrandCard'
import {ProfileItem} from './ProfileItem';
import {WishlistItem} from './WishlistItem';
import {PromocodeItem} from './PromocodeItem';

export const items = {
  OrderItem,
  BrandCard,
  ReviewItem,
  ProductCard,
  ProductCategoryCard,
  ProfileItem,
  WishlistItem,
  PromocodeItem,
  ProductCategoryCardDetail,
  BrandCardDetail,
  ProductHomeCard,
};
